// cohorts/detail hooks
import { queryOptions, useQuery } from "@tanstack/react-query";
import { STALE_TIME } from "@core/libs/react-query";
import { cohortKeys } from "../../_shared/keys";
import { getCohort } from "../services";

/**
 * One cohort. Shared by the route (which loads it before the page opens) and the screens, so both
 * read one cache entry. `operational` tier, and never retried on a 404: a cohort that is gone or
 * out of scope will not come back by asking again.
 */
export function cohortQueryOptions(id: string) {
  return queryOptions({
    queryKey: cohortKeys.detail(id),
    queryFn: () => getCohort(id),
    staleTime: STALE_TIME.operational,
    retry: false,
  });
}

export function useCohort(id: string) {
  return useQuery(cohortQueryOptions(id));
}
